/**
 * @generated SignedSource<<56882135be5cee0638b98e4f9c1b132a>>
 * @relayHash 3f0cf2a6a8e1eb49fcff0b1fe1618827
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 3f0cf2a6a8e1eb49fcff0b1fe1618827

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ccnId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerTypes"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ccnId",
        "variableName": "ccnId"
      },
      {
        "kind": "Variable",
        "name": "offerTypes",
        "variableName": "offerTypes"
      }
    ],
    "concreteType": "UrlResponse",
    "kind": "LinkedField",
    "name": "generateSpidClientUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateSpidClientUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateSpidClientUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3f0cf2a6a8e1eb49fcff0b1fe1618827",
    "metadata": {},
    "name": "GenerateSpidClientUrlMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "f6bc03e21e2cc8a640b3d5596d01abc8";

export default node;
